var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChalkboard = function SvgIconChalkboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 19.75a1 1 0 1 0 0-2H22V5.25a1.75 1.75 0 0 0-1.75-1.75H3.75A1.75 1.75 0 0 0 2 5.25v12.5h-.5a1 1 0 1 0 0 2zm-18.5-2V5.5h16v12.25h-1.75V15a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v2.75h-2.5v-8.5h8.5v2a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1H6.75a1 1 0 0 0-1 1v9.5zM16.25 16v1.75h-4V16z",
    clipRule: "evenodd"
  })));
};
export default SvgIconChalkboard;